import { Box, constants, Image, Text } from '@redbubble/design-system';
import React from 'react';
import styles from './BrandSignal.module.scss';

const BrandSignal = ({ title, description, imageUrl, index }) => {
  return (
    <Box className={styles.brandSignal} display="flex" flexDirection="row">
      <Box marginRight={2}>
        <Image
          size={constants.TINY}
          roundedCorners
          src={imageUrl.src}
          data-testid={`brand-signal-img-${index}`}
        />
      </Box>
      <Box>
        <Text type="display5" block>
          {title}
        </Text>
        <Text>{description}</Text>
      </Box>
    </Box>
  );
};

export { BrandSignal };
